import React from 'react';
import i18next from 'i18next';
import { Redirect } from 'react-router-dom';

import TagForm from './tag_form';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import { TagsService } from '../../services';

class TagEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      added: null,
      tag: null,
      availableTags: null,
      tagId: props.match.params.tagId,
      errorMessage: null,
      localErrorMessage: null,
      deleted: null
    };
  }

  componentDidMount() {
    TagsService.get(this.state.tagId).then((response) => {
      this.setState({ tag: response.tag });
    }).catch((error) => {
      console.error(error);
      this.setState({ errorMessage: i18next.t('messages.could-not-load-tag-edit') });
    });
  }

  handleSubmit({name, tagType}) {
    let updatedTag = {
      id: this.state.tag.id,
      name: name,
      tagType: {id: tagType.value}
    }

    TagsService.save(updatedTag).then(tag => {
      this.setState({ successMessage: i18next.t('messages.tag-saved') });
    }).catch(error => {
      console.error(error);
      this.setState({ localErrorMessage: error.message });
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    } else {
      return null;
    }
  }

  deleteTag() {
    TagsService.remove(this.state.tag.id).then(response => {
      this.setState({successMessage: i18next.t('messages.tag-deleted')});
    }).catch(err => {
      this.setState({errorMessage: i18next.t('messages.tag-associated', {tag: this.state.tag.name})
      })
    })
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/tags',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.successMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/tags',
            state: {
              from: this.props.location,
              successMessage: this.state.successMessage
            }
          }}/>
      );
    }

    if (this.state.tag) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle
                title={i18next.t('pages.tags.edit-tag', {tag: this.state.tag.name})}
                backLinkWithParams={{
                  link: {
                    pathname: "/admin/tags",
                    search: backLinkSearch
                  }
                }}
              />
            </div>

            {this.renderMessages()}

            <TagForm
              tag={this.state.tag}
              onSubmit={this.handleSubmit.bind(this)}
              errorMessage={this.props.errorMessage}
              availableTags={this.state.availableTags}
              onDelete={this.deleteTag.bind(this)}
              backLinkWithParams={{
                link: {
                  pathname: "/admin/tags",
                  search: backLinkSearch
                }
              }}
            />
          </div>
      );
    } else {
      return (
        <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default TagEdit;
